import { client } from "../../../Infrastructure/agent";

export const quaiboDailyProductionService = {
  downloadTemplate: () =>
    client.getFile(
      "/QuaiboDailyProduction/DownloadQuaiboDailyProductionTemplate"
    ),
  saveDailyProduction: (data, welldata, uploadedBy) =>
    client.post("/QuaiboDailyProduction/SaveDailyProduction", {
      data,
      welldata,
      uploadedBy,
    }),

  loadProductionHistory: (query, view) =>
    client.post("/QuaiboDailyProduction/LoadProductionHistory", {
      query,
      view,
    }),
  deleteProduction: (id, prodDate) =>
    client.post("/QuaiboDailyProduction/DeleteProduction", {
      id,
      prodDate,
    }),

  getInitialWellParameters: () =>
    client.get("/QuaiboDailyProduction/GetWellInitials"),

  getWellContributions: (pdate) =>
    client.post("/QuaiboDailyProduction/GetWellContributions", { pdate }),
  getQuaiboProductionById: (productionId, view) =>
    client.post("/QuaiboDailyProduction/GetDailyProduction", {
      productionId,
      view,
    }),
  exportWellAllocation: (startDate, endDate, exportOnlyWellAllocationVolume) =>
    client.getFile(
      `/QuaiboDailyProduction/ExportWellAlocations?startdate=${startDate}&enddate=${endDate}&exportOnlyWellAllocationVolume=${exportOnlyWellAllocationVolume}`
    ),
};

